import React from 'react';
import { t } from '../useTranslations';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, showDetails: false };
    this.handleRetry = this.handleRetry.bind(this);
    this.toggleDetails = this.toggleDetails.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  handleRetry() {
    this.setState({ hasError: false, error: null, showDetails: false });
  }

  toggleDetails() {
    this.setState(s => ({ showDetails: !s.showDetails }));
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const title = t('common.errorBoundary.title');
    const message = t('common.errorBoundary.message');
    const retryLabel = t('common.errorBoundary.retry');
    const detailsLabel = t('common.errorBoundary.details');

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        padding: 'var(--space-xl)',
        textAlign: 'center',
        color: 'var(--color-text)',
      }}>
        <div style={{
          background: 'var(--color-bg-surface)',
          border: '1px solid var(--color-danger-border)',
          borderRadius: 'var(--radius-lg)',
          padding: 'var(--space-xl)',
          maxWidth: '480px',
          width: '100%',
        }}>
          <div style={{
            fontSize: '2.5rem',
            marginBottom: 'var(--space-md)',
          }}>⚠</div>
          <h2 style={{
            fontSize: 'var(--text-lg)',
            fontWeight: 600,
            marginBottom: 'var(--space-sm)',
            color: 'var(--color-danger)',
          }}>{title}</h2>
          <p style={{
            color: 'var(--color-text-secondary)',
            marginBottom: 'var(--space-lg)',
            fontSize: 'var(--text-sm)',
          }}>{message}</p>
          <button
            onClick={this.handleRetry}
            style={{
              background: 'var(--color-primary)',
              color: 'var(--color-text-on-primary)',
              border: 'none',
              borderRadius: 'var(--radius-md)',
              padding: 'var(--space-sm) var(--space-lg)',
              cursor: 'pointer',
              fontSize: 'var(--text-sm)',
              fontWeight: 500,
              marginBottom: 'var(--space-md)',
            }}
          >
            {retryLabel}
          </button>
          {this.state.error && (
            <>
              <button
                onClick={this.toggleDetails}
                style={{
                  display: 'block',
                  margin: '0 auto',
                  background: 'none',
                  border: 'none',
                  color: 'var(--color-text-muted)',
                  cursor: 'pointer',
                  fontSize: 'var(--text-xs)',
                  textDecoration: 'underline',
                }}
              >
                {detailsLabel}
              </button>
              {this.state.showDetails && (
                <pre style={{
                  marginTop: 'var(--space-sm)',
                  padding: 'var(--space-sm)',
                  background: 'var(--color-bg-subtle)',
                  borderRadius: 'var(--radius-sm)',
                  fontSize: '11px',
                  textAlign: 'left',
                  overflow: 'auto',
                  maxHeight: '120px',
                  color: 'var(--color-danger)',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}>
                  {this.state.error.toString()}
                </pre>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
